<div [ngClass]="container.value == value ? 'header expanded' : 'header collapsed'" (click)="activate()">
    <div>{{ label }}</div>
    <div>
        @if (container.value == value) {
            <span class="pi pi-minus"></span>
        } @else {
            <span class="pi pi-plus"></span>
        }
    </div>
</div>
